import * as React from "react";
import axios from "axios";
import { appConfig } from "../reducers/appConfig";
import { UserViewModel } from "../interfaces/UserViewMode";

interface State {
    password: string;
    passwordConf: string;
    errorMsg: string;
    success: boolean;
}

interface Props{
    user: UserViewModel;
}

class SetNewPass extends React.Component<Props, State> {
    constructor(props: Props){
        super(props);
        this.state = {
            password: "",
            passwordConf: "",
            errorMsg: "",
            success: false
        }
    }

    getErrorTranslated = (error: string) => {
        if(error.indexOf("Passwords must have ") != -1){
            return "Паролата трябва да е поне 8 символа и да съдържа малки букви, големи букви, цифра или специален символ";
        }
        switch(error){
            case "Incorrect password.":
                return "Грешна парола"
            default:
                return "Грешна парола"
        }
    }

    changePassword = () => {
        this.setState({...this.state, errorMsg: "", success: false});
        if(!this.state.password || !this.state.passwordConf){
            this.setState({...this.state, errorMsg: "Моля попълнете новата парола", success: false});
            return;
        }
        if(this.state.password != this.state.passwordConf){
            this.setState({...this.state, errorMsg: "Паролата за потвърждение не е същата", success: false})
            return;
        }
        return new Promise((resolve, reject) => {
            axios.post(appConfig.urls.setUserPassword, {
                Password: this.state.password,
                PasswordConfirmation: this.state.passwordConf,
                Name: this.props.user.Name,
                UserName: this.props.user.Username
            })
            .then(r => {
                this.setState({...this.state, errorMsg: "", success: true})
            })
            .catch((e: any) => {
                console.warn(e.response)
                if(e.response && e.response.data && Object.keys(e.response.data).length > 0){
                    if(e.response.data.Errors){
                        this.setState({...this.state, errorMsg: this.getErrorTranslated(e.response.data.Errors[0].Description), success: false})
                    }
                    else{
                        this.setState({...this.state, errorMsg: e.response.data[Object.keys(e.response.data)[0]][0], success: false})
                    }

                }
                else{
                    this.setState({...this.state, errorMsg: "Възникна грешка", success: false})
                }
            })
        })
    }
    render(){
        if(this.state.success){
            return (
                <div style={{width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                    <div style={{color: "green"}}>{`Успешна зададена парола на ${this.props.user.Username}`}</div>
                    <button className="btn btn-success" onClick={() => this.setState({...this.state, errorMsg: "", success: false, password: "", passwordConf: ""})}>Смени паролата отново</button>
                </div>
            )
        }
        return(
            <div style={{ display: "flex", flexDirection: "column", textAlign: "center" }}>
                <input
                    id="password"
                    value={this.state.password}
                    placeholder="Нова парола"
                    onChange={e => {
                        this.setState({ ...this.state, password: e.target.value });
                    }}
                    onKeyUp={(e) => {
                        if(e.keyCode == 13){
                            this.changePassword();
                        }
                    }}
                    type="password"
                    className="form-control" />
                <input
                    id="confirmationPassword"
                    value={this.state.passwordConf}
                    placeholder="Потвърдете нова паролата"
                    onChange={e => {
                        this.setState({ ...this.state, passwordConf: e.target.value });
                    }}
                    onKeyUp={(e) => {
                        if(e.keyCode == 13){
                            this.changePassword();
                        }
                    }}
                    type="password"
                    className="form-control" />
                {this.state.errorMsg ? <div style={{color: "red"}}>{this.state.errorMsg}</div> : null}
                <button className="btn btn-success" onClick={() => {
                    // if (this.state.oldPassword && this.state.password && this.state.passwordConf) {
                        this.changePassword();
                    // }
                }}>Смени паролата</button>
            </div>
        )
    }
}

export default SetNewPass;
